import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
export const NavigateWithSearch = ({ to }) => {
    const { search } = useLocation();
    return React.createElement(Navigate, { to: { pathname: to, search }, replace: true });
};
